import { includes } from 'lodash';

import { getGoalsDecl } from '../declarations/goals/goals';
import {
    ColumnsSettingsViewDict,
    ColumnTypesSettings,
    CommonSettingEditor
} from '../typings/common';
import { Goal, GoalDecl } from '../typings/goals';

import { GridStorageHelper } from './GridStorageHelper/GridStorageHelper';

export function addSettingsToDecl<T extends { key: string }>(
    columns: T,
    columnsSettings: ColumnsSettingsViewDict,
    type: string
): T & ColumnTypesSettings {
    return {
        ...columns,
        ...columnsSettings[type].columnViewInfo[columns.key]
    };
}

export function arrangeInOrder<T extends { key: string }>(
    decls: Array<T>,
    order: string[],
    isAddNewDecls?: boolean
): Array<T> {
    const sortMap = decls.reduce((acc, val) => {
        acc[val.key] = val;

        return acc;
    }, {});

    let newDecls: Array<T> = [];

    if (isAddNewDecls) {
        newDecls = Object.keys(sortMap)
            .filter(key => !includes(order, key))
            .map(value => sortMap[value]);
    }

    return order
        .map(value => sortMap[value])
        .concat(newDecls)
        .filter(Boolean);
}

export function getActiveItemsIds(goals?: GoalDecl[]): string[] | undefined {
    if (!goals) {
        return;
    }

    return goals
        .filter((goal: GoalDecl) => !goal.hidden)
        .map((goal: GoalDecl) => goal.key);
}

export function getCommonSettings(): CommonSettingEditor {
    return {
        isGridTotalBoxVisible: GridStorageHelper.getGridTotalBoxVisibility(),
        isCompactViewEnabled: GridStorageHelper.getCompactViewEnabled(),
        isOnlyFavoriteCampaignsVisible: GridStorageHelper.getOnlyFavoriteCampaignsSetting()
    };
}

export function getGoalsSettingsForColumnsSettingsEditor(
    goals: Record<string, Goal>,
    goalsSettings?: GoalDecl[]
): GoalDecl[] | undefined {
    if (!goals) {
        return undefined;
    }

    const goalsDecls = getGoalsDecl(goals);
    const enabledGoals = getActiveItemsIds(goalsSettings);

    goalsDecls.forEach(goal => {
        goal.hidden = !includes(enabledGoals, goal.key);
    });

    if (!goalsSettings || goalsSettings.length === 0) {
        return goalsDecls;
    }

    const order = goalsSettings.map(goalSetting => goalSetting.key);

    return arrangeInOrder(goalsDecls, order, true);
}
